/** Default contact for GDPR data-subject requests (override per deployment). */
export const DEFAULT_PRIVACY_CONTACT_EMAIL = 'privacy@abraxas.fr';
export function privacyContactMailto(email = DEFAULT_PRIVACY_CONTACT_EMAIL) {
    return `mailto:${email}`;
}
